import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './chips.module.css';
import { colourString } from '../../../library';
function ChipPartial(_a) {
    var label = _a.label, startIcon = _a.startIcon, endIcon = _a.endIcon;
    return (React.createElement(React.Fragment, null,
        !!startIcon && (React.createElement("span", { className: classNames(styles.chipIcon, styles.start) }, startIcon)),
        label,
        !!endIcon && (React.createElement("span", { className: classNames(styles.chipIcon, styles.end) }, endIcon))));
}
export function Chip(_a) {
    var _b, _c;
    var label = _a.label, _d = _a.variant, variant = _d === void 0 ? 'standard' : _d, _e = _a.backgroundColour, backgroundColour = _e === void 0 ? 'default' : _e, borderColour = _a.borderColour, _f = _a.borderRadius, borderRadius = _f === void 0 ? '8px' : _f, _g = _a.colour, colour = _g === void 0 ? 'black' : _g, textOverflowEllipsis = _a.textOverflowEllipsis, onClick = _a.onClick, startIcon = _a.startIcon, endIcon = _a.endIcon, displayBlock = _a.displayBlock;
    var _h = useState({
        backgroundColor: colourString(backgroundColour),
        border: !!borderColour ? "2px solid ".concat(colourString(borderColour)) : "none",
        borderRadius: borderRadius,
        paddingRight: !!endIcon ? '25px' : '15px',
        paddingLeft: !!startIcon ? '25px' : '15px',
        color: colourString(colour),
        cursor: !!onClick ? 'pointer' : 'default',
    }), style = _h[0], setStyle = _h[1];
    useEffect(function () {
        setStyle({
            backgroundColor: colourString(backgroundColour),
            border: !!borderColour ? "2px solid ".concat(colourString(borderColour)) : "none",
            borderRadius: borderRadius,
            paddingRight: !!endIcon ? '25px' : '15px',
            paddingLeft: !!startIcon ? '25px' : '15px',
            color: colourString(colour),
            cursor: !!onClick ? 'pointer' : 'default',
        });
    }, [backgroundColour, borderColour, borderRadius, endIcon, startIcon, colour]);
    if (!!onClick) {
        return (React.createElement("button", { className: classNames("KPLR_Chip", variant === 'tiny' ? 'caption2' : variant === 'large' ? 'body2' : 'caption1', styles.chip, styles[variant], (_b = {},
                _b[styles.textOverflowEllipsis] = textOverflowEllipsis,
                _b[styles.displayBlock] = displayBlock,
                _b)), style: style, onClick: onClick },
            React.createElement(ChipPartial, { label: label, startIcon: startIcon, endIcon: endIcon })));
    }
    return (React.createElement("div", { className: classNames("KPLR_Chip", variant === 'tiny' ? 'caption2' : variant === 'large' ? 'body2' : 'caption1', styles.chip, styles[variant], (_c = {},
            _c[styles.textOverflowEllipsis] = textOverflowEllipsis,
            _c[styles.displayBlock] = displayBlock,
            _c)), style: style },
        React.createElement(ChipPartial, { label: label, startIcon: startIcon, endIcon: endIcon })));
}
export default Chip;
